import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createContext, useContext, useMemo, useState } from 'react';
import ReactDOM from 'react-dom';
import { useOnMount } from '~/hooks/useOnMount';
const MobileOptimizedViewContext = /*#__PURE__*/ createContext({
    acquireOptimizedViewport: ()=>()=>{}
});
const typeToContent = {
    standard: 'width=1280',
    optimized: 'width=device-width, initial-scale=1.0, maximum-scale=1.0'
};
/** Controls the viewport width in mobile devices. */ export function MobileViewportWidthProvider(param) {
    let { children } = param;
    const [optimizedCount, setOptimizedCount] = useState(0);
    const type = optimizedCount > 0 ? 'optimized' : 'standard';
    const value = useMemo(()=>({
            acquireOptimizedViewport: ()=>{
                setOptimizedCount((c)=>c + 1);
                return ()=>setOptimizedCount((c)=>c - 1);
            }
        }), []);
    return /*#__PURE__*/ _jsxs(MobileOptimizedViewContext.Provider, {
        value: value,
        children: [
            /*#__PURE__*/ ReactDOM.createPortal(/*#__PURE__*/ _jsx("meta", {
                name: "viewport",
                content: typeToContent[type],
                "data-testid": "viewport"
            }), document.head),
            children
        ]
    });
}
const useMobileViewport = ()=>useContext(MobileOptimizedViewContext);
export function useOptimizedMobileViewport(enabled) {
    const { acquireOptimizedViewport } = useMobileViewport();
    useOnMount(()=>{
        if (enabled) {
            const cancel = acquireOptimizedViewport();
            return ()=>cancel();
        }
    });
}
/**
 * When a page is wrapped by this higher-order component, it tells the mobile-browser that it's a mobile-optimized page
 * and the browser will enforce viewport width to be the device width.
 */ export function withOptimizedMobileViewport(Component) {
    return function WithOptimizedMobileViewport(props) {
        useOptimizedMobileViewport(true);
        return /*#__PURE__*/ _jsx(Component, _object_spread({}, props));
    };
}
